"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "BackButton", {
  enumerable: true,
  get: function get() {
    return _BackButton.default;
  }
});

_Object$defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});

_Object$defineProperty(exports, "NextButton", {
  enumerable: true,
  get: function get() {
    return _NextButton.default;
  }
});

var _BackButton = _interopRequireDefault(require("./BackButton/BackButton"));

var _Button = _interopRequireDefault(require("./Button/Button"));

var _NextButton = _interopRequireDefault(require("./NextButton/NextButton"));